import React from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, navigate } from '@reach/router';

import messages from './Messages';
import Button from 'components/Button';
import image from 'assets/images/404.png';

type IComponentProps = RouteComponentProps;

const NotFound: React.FC<IComponentProps> = () => {
  return (
    <article style={{ display: 'grid', justifyContent: 'center' }}>
      <Helmet>
        <title>{messages.notFound}</title>
        <meta name="description" content={messages.notFound} />
      </Helmet>
      <h4 style={{ textAlign: 'center', marginTop: '100px' }}>
        {messages.notFoundMessage}
      </h4>
      <img
        style={{ maxHeight: '80vp', maxWidth: '80vw', margin: 'auto' }}
        src={image}
        alt="not-found"
      />
      <Button
        style={{ width: '150px', margin: 'auto' }}
        onClick={() => {
          navigate('/homepage');
        }}
      >
        {messages.home}
      </Button>
    </article>
  );
};

export default NotFound;
